<template>
  <!-- Start Tll remaining days -->
  <div class="m-tll" v-if="tllRemainingDays">
    <div class="m-tll__discount">
      Your prepaid credit - {{ tllRemainingDays }} days
        <span class="a-tooltip"
          @click="toggleTooltip"
          @mouseover="toggleTooltip"
          @mouseleave="toggleTooltip">
          <span class="a-tooltip__trigger" ref="tooltipTrigger">
            <i class="fas fa-question-circle"></i>
          </span>
          <span class="a-tooltip__bubble a-tooltip__bubble--top" ref="tooltipBubble">
            <div class="a-tooltip__bubble__body">
              Your credit card will be billed after your prepaid balance has been used up.
            </div>
            <div class="a-tooltip__arrow" data-popper-arrow></div>
          </span>
        </span>
    </div>
    <hr>
    <div v-if="subscriptionPromotion" class="m-tll__description green-text">
      <div class="row m-tll__description--title"><span>Discount</span> - {{ promotionDescription }}</div>
      <div class="row m-tll__description--billingPeriod">
        {{currency}} {{ promotionOriginalPrice }}
        {{ subscriptionBillingPeriodCycle(promotionProductBillingPeriod) }} once promotion ends
      </div>
    </div>
    <hr v-if="promotionEndDate && promotionDescription">
  </div>
  <!-- end tll remaining days -->
</template>

<script>
import { mapState } from 'vuex'
import * as Popper from '@popperjs/core'
export default {
  computed: mapState({
    item: state => state.cart.items[0],
    currency: state => state.cart.currency,
    tllRemainingDays: state => state.cart.items[0] ? state.cart.items[0].tll_remaining_days : 0,
    promotionEndDate: state => state.cart.items[0] ? state.cart.items[0].promotion_end_date : null,
    subscriptionPromotion () {
      if (
        this.item !== undefined &&
        this.item.base_price !== this.item.price &&
        this.item.product_type.subscription
      ) {
        this.promotionDescription = this.item.promotion_description
        this.promotionOriginalPrice = this.item.total_amount_without_promotion
        this.promotionProductBillingPeriod = this.item.product_type.billing_period
        return true
      }
      return false
    }
  }),
  methods: {
    subscriptionBillingPeriodCycle (billingPeriod) {
      switch (billingPeriod) {
        case 0:
          return ''
        case 1:
          return '/m'
        case 12:
          return '/y'
        default:
          return ' every ' + billingPeriod + ' months'
      }
    },
    toggleTooltip () {
      // Toggle showTooltip
      this.showTooltip = !this.showTooltip
      if (this.showTooltip) this.createPopper()
    },
    createPopper () {
      this.destroyPopper() // Ensure that there are no other popper instances at this point
      const skidding = 0 // Cross axis offset of bubble with respect to its natural placement
      const distance = 12 // Main axis offset of bubble relative to the trigger
      const arrowPadding = 12 // Padding determines the minimum distance between the arrow and the edge of the bubble

      this.popperInstance = Popper.createPopper(
        this.$refs.tooltipTrigger,
        this.$refs.tooltipBubble,
        {
          placement: 'top',
          modifiers: [
            {
              name: 'flip',
              enabled: true,
              options: {
                flipVariations: false // Since we have `preventOverflow` this is redundant
              }
            },
            {
              name: 'preventOverflow',
              enabled: true
            },
            {
              name: 'offset',
              options: {
                offset: [skidding, distance]
              }
            },
            {
              name: 'arrow',
              options: {
                padding: arrowPadding
              }
            }
          ]
        }
      )
    },
    destroyPopper () {
      if (this.popperInstance) {
        this.popperInstance.destroy()
        this.popperInstance = null
      }
    }
  },
  data () {
    return {
      showTooltip: false,
      popperInstance: null,
      promotionDescription: '',
      promotionOriginalPrice: 0,
      promotionProductBillingPeriod: 0
    }
  }
}
</script>

<style lang="scss" scoped>
// Start CSS for Tll remaining days
.m-tll {
  .m-tll__discount {
    margin-bottom: 20px;
  }
  .m-tll__description {
    .m-tll__description--billingPeriod {
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
}
// End CSS for Tll remaining days
</style>



// WEBPACK FOOTER //
// Tll.vue?6f355ba2